import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import i18n from '@shared/i18n/index';
import { NewBaseButton } from '@shared/components/base/NewBaseButton';

import styles from './index.module.less';
import Content from './emptyStateImage/Content.png';
import Image from './emptyStateImage/Image.png';
import Style from './emptyStateImage/Style.png';
import Search from './emptyStateImage/Search.png';
import Application from './emptyStateImage/Application.png';
import { BaseImage } from '../BaseImage';

const imageMap = {
	Application: Application,
	Content: Content,
	Image: Image,
	Search: Search,
	Style: Style,
};

interface EmptyStateProps {
	type?: 'Application' | 'Content' | 'Image' | 'Search' | 'Style';
	imageSize?: number;
	contain?: ReactNode; // contain 子元素
	detail?: ReactNode; // detail 子元素
	onClick?: () => void; // 点击事件
	buttonText?: string;
	hasButton?: boolean;
	backgroundColor?: string;
	backgroundStyle?: React.CSSProperties;
	detailStyle?: React.CSSProperties;
	containStyle?: React.CSSProperties;
	imageClass?: string;
	imageStyle?: React.CSSProperties;
	containClass?: string;
}

export const EmptyState: FC<EmptyStateProps> = (props) => {
	const {
		type = 'Content',
		imageSize = 200,
		contain,
		detail,
		onClick,
		buttonText = i18n.get('Build_BuildPage_Example'),
		hasButton = true,
		backgroundStyle,
		backgroundColor,
		detailStyle,
		containStyle,
		imageClass,
		imageStyle,
		containClass,
	} = props;

	return (
		<div
			className={styles.backGround}
			style={{ backgroundColor: backgroundColor, ...backgroundStyle }}
		>
			<div className={styles.container}>
				<BaseImage
					className={classNames(
						{
							[styles.emptyImage]: true,
						},
						imageClass,
					)}
					style={{ width: `${imageSize}px`, height: `${imageSize}px`, ...imageStyle }}
					src={imageMap[type]}
					alt=""
				/>
				{contain && (
					<div className={classNames(styles.contain, containClass)} style={containStyle}>
						{contain}
					</div>
				)}
				{detail && (
					<div className={styles.detail} style={detailStyle}>
						{detail}
					</div>
				)}
				{hasButton && (
					<NewBaseButton preset="secondary" onClick={onClick} className={styles.buttonStyle}>
						{buttonText}
					</NewBaseButton>
				)}
			</div>
		</div>
	);
};

export default EmptyState;
